import React from 'react';

import type { TransactionType } from 'types/api/transaction';

import Tag from 'ui/shared/chakra/Tag';

import { camelCaseToSentence } from './noves/utils';
import TxType from './TxType';

export interface Props {
  types: Array<TransactionType>;
  isLoading?: boolean;
  translatationType: string | undefined;
  variant?: 'default' | 'explorer';
}

const TxTranslationType = ({ types, isLoading, translatationType, variant = 'default' }: Props) => {

  const filteredTypes = [ 'unclassified' ];

  if (!translatationType || filteredTypes.includes(translatationType)) {
    return <TxType types={ types } isLoading={ isLoading } variant={ variant }/>;
  }

  return (
    <Tag
      colorScheme="purple"
      isLoading={ isLoading }
      bgColor={ variant === 'explorer' ? '#171717' : undefined }
      borderWidth={ variant === 'explorer' ? '1px' : undefined }
      borderColor={ variant === 'explorer' ? '#222222' : undefined }
      color={ variant === 'explorer' ? '#FFFFFF' : undefined }
      fontSize="12px"
      fontWeight={ variant === 'explorer' ? 500 : undefined }
      lineHeight="16px"
      fontFamily="'Space Grotesk', var(--chakra-fonts-body)"
      borderRadius="4px"
      px="8px"
      py="2px"
      minH="24px"
      maxW="100%"
      isTruncated
    >
      { camelCaseToSentence(translatationType) }
    </Tag>
  );

};

export default TxTranslationType;
